import React, { Component } from 'react'
import { Col, Row, Input, Label } from 'reactstrap'
import ModalForm from '../../../comum/components/ModalForm'
import { observer } from 'mobx-react'
import FormInputSimples from '../../../comum/components/FormInputSimples'
import NovoDirecionamentoStore from '../stores/NovoDirecionamentoStore'
import { IconeFechar } from '../../../comum/components/Icones'

@observer
export default class IncluirDirecionamento extends Component {
    
    constructor(props) {
        super(props)

        this.direcController = this.props.controller
        this.controller = new NovoDirecionamentoStore()

        this.handleSalvar = this.handleSalvar.bind(this)
        
    }
    
    componentDidMount() {
        if(this.direcController.editando){
            this.controller.setDadosEdicao(this.direcController.elementoEmEdicao)
        }
    }

    handleSalvar() {
        this.controller.adicionar = true
        //Tenho que fazer uma variável no store de direcionamento ficar true e abrir a tabela de adições
        //this.direcController.adicionarDirecionamento(this.controller.ceHouse,this.controller.emails,this.controller.codRef,this.controller.listaAnexos)
        if(!this.alertaCeHouse() && !this.direcController.editando){
            this.direcController.adicionarListaAdicoes(this.controller.ceHouse,this.controller.emails,this.controller.codRef,this.controller.listaAnexos)
            this.direcController.mostrarTabelaAdicionar()
            this.direcController.fecharModalAdicionar()
        }else if(!this.alertaCeHouse() && this.direcController.editando){
            this.direcController.alterarDadosEdicao(this.controller.ceHouse,this.controller.emails,this.controller.codRef,this.controller.listaAnexos)
            this.direcController.fecharEdicao()
        }
    }

    alertaCeHouse = () => {
        if(this.controller.adicionar && this.controller.ceHouse.length === 0){
            return "Campo obrigatório"
        }else{
            return false
        }
    }

    render() {
        return (
            <ModalForm
                className="modal-direcionamento"
                labelConfirmar = "CONFIRMAR"
                onClickCancelar = {this.direcController.editando ? this.direcController.fecharEdicao : this.direcController.fecharModalAdicionar}
                onClickSalvar = {this.handleSalvar}
            >
                <h2>
                    {
                        this.direcController.editando
                        ? "Editar direcionamento"
                        : "Novo direcionamento"
                    }
                </h2>
                <Row>
                    <FormInputSimples xs={12} sm={12} md={6} lg={6} xl={6}
                       titulo="CE House"
                       dado={this.controller.ceHouse}
                       obrigatorio={true}
                       limiteMaximo={15}                      
                       alerta={this.alertaCeHouse()}
                       onChange={(event) => {
                        const value = event.target.value;
                        // Permitir apenas números
                        if (/^\d*$/.test(value)) {
                          this.controller.setCeHouse(value);
                        }
                      }}
                        
                    />
                    <FormInputSimples xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Código de referêcia"
                        dado={this.controller.codRef}
                        onChange={(event) => this.controller.setCodRef(event.target.value)}
                    />
                    <FormInputSimples xs={12} sm={12} md={12} lg={12} xl={12}
                        titulo="Emails"
                        dado={this.controller.emails}
                        onChange={(event) => this.controller.setEmails(event.target.value)}
                    />
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Label>Anexos</Label>
                        { this.controller.listaAnexos.length > 0
                        ? <Col xs={12} md={12} className="mb-4">{
                            this.controller.listaAnexos.map((item, index) =>
                                <div key={index} className={`item-anexo`}>
                                    <span>{`${item.name}`}</span>
                                    <span className="ml-2">
                                        {/* <Baixar tamanho="lg" className="mr-2" onClick={() => this.controller.baixarAnexo(item.Id, index)} /> */}
                                        <IconeFechar tamanho="lg" onClick={() => this.controller.removerAnexo()} />
                                    </span>
                                </div>
                            )}
                        </Col>
                        : <React.Fragment>
                            <Input className="p-2 mb-4" type="file" onChange={e => this.controller.anexarArquivo(e)} accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" />
                        </React.Fragment>
                    }
                    </Col>
                </Row>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/tecon/components/IncluirDirecionamento.js